module.exports = __webpack_public_path__ + "static/small-logo-6134277f7c2b0c3341bb27867607de13.svg";